import React from 'react';
import classnames from 'classnames';

import './LoadingSpinner.scss';

export enum LoadingSpinnerSizeModifiers {
  small = 'sm',
}

export interface LoadingSpinnerProps {
  size?: LoadingSpinnerSizeModifiers;
  label?: string;
}

const LoadingSpinner = ({
  size = LoadingSpinnerSizeModifiers.small,
  label = 'Loading...',
}: LoadingSpinnerProps) => (
  <div className={classnames('loader', size)}>{label}</div>
);

export { LoadingSpinner };
